<template>
  <section class="team" id="team">
    <custom-title text="The Founders" header-class="founders-title" text-colour="white" stripe-colour="#E1A3C6"></custom-title>
    <div class="founders cards">
      <founder v-for="(founder, key) in founders" :key="key" :founder="founder" />
    </div>
    <br />
    <br />
    <!-- <custom-title text="The Team" header-class="team-title" text-colour="white" stripe-colour="#FEDD8A"></custom-title> -->
    <!-- <div class="map"></div> -->
    <!-- <p>The real heroes of the operation - we wouldn't be able to do what we do if it wasn't for our Unicorns who come together from across the globe every day to work together on creating magic.</p> -->
    <!-- <ul class="team cards"> -->
      <!-- <team-member v-for="(person, key) in team" :key="key" :person="person" /> -->
    <!-- </ul> -->
    <team-clouds></team-clouds>
  </section>
</template>

<style lang="scss">
  .team {
    background: #1B1D50;
    border-top: 2px solid #333570;
  }

  p {
    color: #D3D6DE;
    margin: 1rem auto;
    max-width: 80%;
    width: 600px;
    font-size: 1.1rem;
    text-align: left;
  }

  b {
    color: white;
    font-family: 'OpenSans-Bold', sans-serif;
    font-weight: 700;
  }

  .map {
    width: 100%;
    height: 300px;
    background-image: url('../assets/map-unicorn.jpg');
    background-attachment: fixed;
    background-size: cover;
    background-position-x: 50%;
    background-position-y: 80%;
    margin: 1em 0;
  }

  .cards {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    list-style: none;
    margin: 0;
  }
</style>

<script>
import TeamClouds from './TeamClouds'
import Founder from './Founder'
// import TeamMember from './TeamMember'
import CustomTitle from './CustomTitle'

export default {
  components: {
    Founder,
    // TeamMember,
    TeamClouds,
    CustomTitle
  },
  data () {
    return {
      founders: [
        {
          name: 'Darryn Ten',
          position: 'CTO',
          location: 'Global',
          image: require('../assets/team/darryn.png')
        },
        {
          name: 'Tammy Germany',
          position: 'COO',
          location: 'Global',
          image: require('../assets/team/tammy.png')
        }
      ],
      team: [
        {
          name: 'Brian',
          position: 'DevOps',
          location: 'Nairobi, Kenya',
          image: require('../assets/team/brian.png')
        },
        {
          name: 'Cara',
          position: 'Copywriter',
          location: 'Cape Town, South Africa',
          image: require('../assets/team/cara.png')
        },
        {
          name: 'Daniel',
          position: 'Frontend',
          location: 'Lagos, Nigeria',
          image: require('../assets/team/daniel.jpeg')
        },
        {
          name: 'Fergus',
          position: 'Backend',
          location: 'Cape Town, South Africa',
          image: require('../assets/team/fergus.png')
        },
        {
          name: 'Ihor',
          position: 'Frontend',
          location: 'Kyiv, Ukraine',
          image: require('../assets/team/ihor.png')
        },
        {
          name: 'Max',
          position: 'iOS',
          location: 'Kyiv, Ukraine',
          image: require('../assets/team/max.png')
        },
        {
          name: 'Mladen',
          position: 'Frontend',
          location: 'Podgorica, Montenegro',
          image: require('../assets/team/mladen.png')
        },
        {
          name: 'Nikesh',
          position: 'iOS',
          location: 'Banepa, Nepal',
          image: require('../assets/team/nikesh.png')
        },
        {
          name: 'Ridwan',
          position: 'Android',
          location: 'Yogyakarta, Indonesia',
          image: require('../assets/team/reid.png')
        },
        {
          name: 'Ritesh',
          position: 'Android',
          location: 'Kathmandu, Nepal',
          image: require('../assets/team/ritesh.png')
        },
        {
          name: 'Serhii',
          position: 'Design',
          location: 'Kyiv, Ukraine',
          image: require('../assets/team/serhii.png')
        },
        {
          name: 'Steve',
          position: 'Full Stack',
          location: 'Nairobi, Kenya',
          image: require('../assets/team/steve.png')
        }
      ]
    }
  }
}
</script>
